export const PropertyActionsTypes = {
  LOAD_PROPERTIES: '[Property] Load Properties',
  LOAD_PROPERTIES_SUCCESS: '[Property] Load Properties Success',
  LOAD_PROPERTIES_FAILURE: '[Property] Load Properties Failure',

  LOAD_PROPERTIES_AREA_INFO: '[Property] Load Properties Area Info',
  LOAD_PROPERTIES_AREA_INFO_SUCCESS: '[Property] Load Properties Area Info Success',
  LOAD_PROPERTIES_AREA_INFO_FAILURE: '[Property] Load Properties Area Info Failure',

  LOAD_PROPERTY_DATA: '[Property] Load Property Data',
  LOAD_PROPERTY_DATA_SUCCESS: '[Property] Load Property Data Success',
  LOAD_PROPERTY_DATA_FAILURE: '[Property] Load Property Data Failure',

  LOAD_PROPERTY_PHENOMENA: '[Property] Load Property Phenomena',
  LOAD_PROPERTY_PHENOMENA_SUCCESS: '[Property] Load Property Phenomena Success',

  LOAD_PROPERTY_INDICATORS_SUCCESS: '[Property] Load Property Indicators Success',
  LOAD_PROPERTY_METHODOLOGIES_SUCCESS: '[Property] Load Property Methodologies Success',

  LOAD_PROPERTY_TIME: '[Property] Load Property Time',
  LOAD_PROPERTY_TIME_SUCCESS: '[Property] Load Property Time SUCCESS',

  GET_CURRENT_SEASON_AREAS: '[Property] Get Current Season Areas',
  GET_CURRENT_SEASON_AREAS_SUCCESS: '[Property] Get Current Season Areas Success',
  GET_CURRENT_SEASON_AREAS_FAILURE: '[Property] Get Current Season Areas Failure',

  LOAD_SEVERITY_BY_INDICATOR: '[Property] Load severity by indicator',
  LOAD_SEVERITY_BY_INDICATOR_SUCCESS: '[Property] Load severity by indicator Success',
  CLEAR_INDICATOR_SEVERITY: '[Property] Clear indicator severity',
  GET_SEASON_AREAS_BY_DATE: '[Property] Get Season Areas By Date',
  GET_SEASON_AREAS_BY_DATE_SUCCESS: '[Property] Get Season Areas By Date Success',
  GET_SEASON_AREAS_BY_DATE_FAILURE: '[Property] Get Season Areas By Date Failure',

  SET_USE_NEW_MAP_COLORS_FLAG: '[Property] Set value for use new colors flag',
  SET_PROPERTY_BASIC_DATA_IS_LOADED: '[Property] Set value for property basic data is loaded'
} as const;
